import { render, staticRenderFns } from "./waterCost.vue?vue&type=template&id=47c361f1&scoped=true"
import script from "./waterCost.vue?vue&type=script&lang=js"
export * from "./waterCost.vue?vue&type=script&lang=js"
import style0 from "./waterCost.vue?vue&type=style&index=0&id=47c361f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c361f1",
  null
  
)

export default component.exports